import React from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const TextFieldWithValidation = ({ label, type, value, setValue, validate, showEye }) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleToggleVisibility = () => setShowPassword(!showPassword);

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      value={value}
      type={showPassword && showEye ? "text" : type}
      onChange={(e) => (!validate || validate(e.target.value)) && setValue(e.target.value)}
      InputProps={{
        endAdornment: showEye && (
          <InputAdornment position="end">
            <IconButton onClick={handleToggleVisibility} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TextFieldWithValidation;
